import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        site: '=',
        tree: '<'
    },
    template: `
        <h1>{{ 'sites.Edit site' | translate }}</h1>
        <manage-permissions-sites-form tree="vm.tree" site="vm.site"/>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/sites/edit/index.js